// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_Aws","cls2":"CitingSourcesCard-cls2_C2c CitingSourcesCard-cls1_Aws"};